import {gql} from "apollo-boost";

export const SSOQuery = gql`
    query Affiliate($deviceId: String!){
        ssoLogin(deviceId:$deviceId)
    }`;